import { motion } from "framer-motion";

export const ScorePanel = ({ xWins, oWins, draws, currentPlayer, playerXName = "X", playerOName = "O" }) => {
  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="glass-card-strong rounded-2xl p-3 sm:p-4 mb-4 w-full max-w-md mx-auto"
      data-testid="score-panel"
    >
      <div className="grid grid-cols-3 gap-2">
        {/* Player X */}
        <motion.div 
          data-testid="score-display-x"
          animate={currentPlayer === 'X' ? { scale: [1, 1.05, 1] } : {}}
          transition={{ duration: 1, repeat: Infinity }}
          className={`text-center p-2 rounded-xl border-2 transition-all ${currentPlayer === 'X' ? 'border-yellow-400/60 bg-yellow-400/10 shadow-[0_0_15px_rgba(255,215,0,0.2)]' : 'border-transparent'}`}
        >
          {/* Mini X icon */}
          <svg width="28" height="28" viewBox="0 0 28 28" className="mx-auto mb-1">
            <defs>
              <linearGradient id="mini-x" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFD700" />
                <stop offset="100%" stopColor="#FFA500" />
              </linearGradient>
            </defs>
            <line x1="6" y1="6" x2="22" y2="22" stroke="url(#mini-x)" strokeWidth="4" strokeLinecap="round" />
            <line x1="22" y1="6" x2="6" y2="22" stroke="url(#mini-x)" strokeWidth="4" strokeLinecap="round" />
          </svg>
          <div className="font-fredoka text-sm font-bold text-yellow-300 truncate">{playerXName}</div>
          <div className="font-fredoka text-gold text-2xl sm:text-3xl font-bold">{xWins}</div>
        </motion.div>

        {/* Draws */}
        <div data-testid="score-display-draw" className="text-center p-2 rounded-xl flex flex-col items-center justify-center">
          <div className="font-fredoka text-base font-bold text-gold-light/60">Seri</div>
          <div className="font-fredoka text-gold-light/60 text-2xl sm:text-3xl font-bold">{draws}</div>
        </div>

        {/* Player O */}
        <motion.div 
          data-testid="score-display-o"
          animate={currentPlayer === 'O' ? { scale: [1, 1.05, 1] } : {}}
          transition={{ duration: 1, repeat: Infinity }}
          className={`text-center p-2 rounded-xl border-2 transition-all ${currentPlayer === 'O' ? 'border-orange-400/60 bg-orange-400/10 shadow-[0_0_15px_rgba(255,107,53,0.2)]' : 'border-transparent'}`}
        >
          {/* Mini O icon */}
          <svg width="28" height="28" viewBox="0 0 28 28" className="mx-auto mb-1">
            <defs>
              <linearGradient id="mini-o" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FF6B35" />
                <stop offset="100%" stopColor="#FF3366" />
              </linearGradient>
            </defs>
            <circle cx="14" cy="14" r="9" fill="none" stroke="url(#mini-o)" strokeWidth="3.5" strokeLinecap="round" />
          </svg>
          <div className="font-fredoka text-sm font-bold text-orange-300 truncate">{playerOName}</div>
          <div className="font-fredoka text-gold text-2xl sm:text-3xl font-bold">{oWins}</div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ScorePanel;
